import React from 'react';
import Select from 'react-select';
import { multiSelectStatisticDataSettings } from '../../constants/statisticSettings';


const MultiSelect = React.forwardRef(({ options = multiSelectStatisticDataSettings, ...props }, ref) => ( // give a default value to options if not provided
    <Select className='w-full rounded-md form-style'
        closeMenuOnSelect={true}
        defaultValue={[]}
        isMulti
        options={options}
        ref={ref}
        {...props}

    //  styles={colourStyles}
    />

));


export default MultiSelect;